export interface StockPanelSearchBarProps {
  className?: string;
  isLoading?: boolean;
  placeholderText: string;
  val?: string;

  onBack?(): void;

  onSearch(searchTerm: string): void;

  /** Reports every change to the visible input text (typing, clearing, recent-search picks, external resets) — unlike onSearch, which only fires on commit. */
  onInputTextChange?(text: string): void;
}

export const SEARCH_CONTROL_ID = {
  CANCEL: 'cancel',
  SEARCH: 'search',
} as const;
